import React from "react";
import { Link } from 'react-router-dom';
import useData from '../../Hooks/useData';

// Role ID legend — mirrors SideNav.js
//   8  = BOM Super Administrator
//   32 = BOM Administrator
//   33 = BOM Finance
//   24 = BOM Check-In Staff
//   35 = BOM Event Administrator
//   38 = BOM Event Coordinator

 {/* ── Role ID legend ──────────────────────────────────────────────
             32/8  = BOM Super Administrator  (full access)
             33/32 = BOM Administrator        (no Payments, no Settings)
             285/33 = BOM Finance              (Events, Users, Payments, Reporting)
             38/24 = BOM Check-In Staff       (Check-In only)
             35 = BOM Event Administrator  (Events, Users, Certifications, Check-In, Reporting)
             18/38 = BOM Event Coordinator    (Events, Users)
           ──────────────────────────────────────────────────────────────── */}

const dashboardList = [
  { id: 1, name: 'Events',         icon: 'icon-calendar py-5', url: './events',         allowedRoles: [32, 33, 285, 35, 18] },
  { id: 2, name: 'Users',          icon: 'icon-user py-5',     url: './users',          allowedRoles: [32, 33, 285, 35, 18] },
  { id: 3, name: 'Payments',       icon: 'icon-wallet py-5',   url: './finances',       allowedRoles: [32, 33, 285]             },
  { id: 4, name: 'Certifications', icon: 'icon-star py-5',     url: './certifications', allowedRoles: [32, 33, 35]         },
  { id: 5, name: 'Reporting',      icon: 'icon-edit py-5',     url: './reporting',      allowedRoles: [32, 33, 285, 35]     },
  { id: 6, name: 'Check-In',       icon: 'icon-checkin py-5',  url: './checkin',        allowedRoles: [32, 33, 38, 35]     },
  { id: 7, name: 'Roles',          icon: 'icon-roles py-5',    url: './roles',          allowedRoles: [32, 33]             },
  { id: 8, name: 'Settings',       icon: 'icon-settings py-5', url: './settings',       allowedRoles: [32]                 },
];



const DashboardTile = (props) => {
  return(
      <div className="post-card col-md-4 mb-4">
          <Link to={props.url}>
            <div className="card text-center"> <i className={props.icon}></i>
              <div className="card-body">
                <h5 className="card-title">{props.name}</h5>
              </div>
            </div>
          </Link> 
    </div>
  )
}


const Dashboard = () => {
  const { auth } = useData();
  const userRoleIds = auth?.roles?.map((r) => r.RoleID) || [];

  const visibleTiles = dashboardList.filter((tile) =>
    tile.allowedRoles.some((r) => userRoleIds.includes(r))
  );

  return (
    <div style={{ padding: '24px' }}>
      <div className="row">
        {visibleTiles.map((dashitem) =>
          <DashboardTile
            key={dashitem.id}
            name={dashitem.name}
            url={dashitem.url}
            icon={dashitem.icon}
          />
        )}
      </div>
    </div>
  );
}

export default Dashboard;